import useObservable from "./useObservable";
import { inlineHelpContentStore$ } from "../store/inlineHelpContentStore";
function useInlineHelpContent() {
    var response = useObservable(inlineHelpContentStore$).response;
    return {
        response: response
    };
}
export default useInlineHelpContent;

//# sourceMappingURL=useInlineHelpContent.js.map